var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	5724: {
		fallback: function() { return function() { return __webpack_require__(5723); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	4867: {
		fallback: function() { return Promise.all([__webpack_require__.e(1629), __webpack_require__.e(3432), __webpack_require__.e(2825), __webpack_require__.e(5724), __webpack_require__.e(3517), __webpack_require__.e(144)]).then(function() { return function() { return __webpack_require__(2025); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",

	},
	698: {
		fallback: function() { return __webpack_require__.e(9053).then(function() { return function() { return __webpack_require__(1434); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",

	},
	2886: {
		fallback: function() { return Promise.all([__webpack_require__.e(1629), __webpack_require__.e(5212)]).then(function() { return function() { return __webpack_require__(5212); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",

	},
	3716: {
		fallback: function() { return Promise.all([__webpack_require__.e(3432), __webpack_require__.e(3517), __webpack_require__.e(487)]).then(function() { return function() { return __webpack_require__(5771); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",

	},
	4748: {
		fallback: function() { return Promise.all([__webpack_require__.e(6783), __webpack_require__.e(3517), __webpack_require__.e(8116)]).then(function() { return function() { return __webpack_require__(6783); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",

	},
	6636: {
		fallback: function() { return __webpack_require__.e(4405).then(function() { return function() { return __webpack_require__(9167); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",

	},
	9065: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(2155); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	4492: {
		fallback: function() { return __webpack_require__.e(3818).then(function() { return function() { return __webpack_require__(3818); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",

	},
	1449: {
		fallback: function() { return __webpack_require__.e(5235).then(function() { return function() { return __webpack_require__(5235); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",

	},
	3134: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(8997); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	3517: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(316); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	5997: {
		fallback: function() { return __webpack_require__.e(1548).then(function() { return function() { return __webpack_require__(9167); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",

	},
	9978: {
		fallback: function() { return __webpack_require__.e(9565).then(function() { return function() { return __webpack_require__(9565); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	},
	579: {
		fallback: function() { return Promise.all([__webpack_require__.e(1629), __webpack_require__.e(5212), __webpack_require__.e(807)]).then(function() { return function() { return __webpack_require__(5212); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",

	},
	8319: {
		fallback: function() { return __webpack_require__.e(9053).then(function() { return function() { return __webpack_require__(1434); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",

	},
	6869: {
		fallback: function() { return __webpack_require__.e(6783).then(function() { return function() { return __webpack_require__(6783); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",

	},
	5898: {
		fallback: function() { return __webpack_require__.e(7061).then(function() { return function() { return __webpack_require__(7061); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [5724,4867,698,2886,3716,4748,6636,9065,4492,1449,5724,9065,3134,3517,8319,6869,5997,579,9978,4867,5898];
__webpack_require__.federation.installInitialConsumes = function(options) { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"636": [
		8319,
		6869,
		5997,
		579,
		9978,
		4867,
		5898
	],
	"3517": [
		3517
	],
	"3814": [
		5997,
		9978
	],
	"4867": [
		4867
	],
	"5527": [
		698,
		2886,
		3716,
		4748,
		6636,
		9065,
		4492,
		1449
	],
	"5724": [
		5724
	],
	"8006": [
		579
	],
	"8792": [
		5724,
		9065,
		3134,
		3517
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}